import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IConfigurationXStore } from "src/models/Stores/Store.models";

interface ConfigurationXStoreState {
  configurationXStores: IConfigurationXStore[];
  configurationXStoreToEdit: IConfigurationXStore | null;
}

const initialState: ConfigurationXStoreState = {
  configurationXStores: [],
  configurationXStoreToEdit: null,
};

const paymentMethodXStoreSlice = createSlice({
  name: "ConfigurationXStore",
  initialState,
  reducers: {
    setConfigurationXStoreList: (
      state,
      action: PayloadAction<IConfigurationXStore[]>
    ) => {
      state.configurationXStores = action.payload;
    },
    concatListConfigurationXStore: (
      state: ConfigurationXStoreState,
      action: PayloadAction<IConfigurationXStore[]>
    ) => {
      state.configurationXStores = [
        ...state.configurationXStores.concat(action.payload),
      ];
    },
    addConfigurationXStore: (
      state,
      action: PayloadAction<IConfigurationXStore>
    ) => {
      state.configurationXStores.push(action.payload);
    },
    setConfigurationXStoreToEdit: (
      state,
      action: PayloadAction<IConfigurationXStore | null>
    ) => {
      state.configurationXStoreToEdit = action.payload;
    },
    updateConfigurationXStore: (
      state,
      action: PayloadAction<IConfigurationXStore>
    ) => {
      let itemIndex = state.configurationXStores.findIndex(
        item =>
          item.configurationXStoreId === action.payload.configurationXStoreId
      );
      if (itemIndex !== -1)
        state.configurationXStores[itemIndex] = action.payload;
    },
  },
});

export const {
  setConfigurationXStoreList,
  concatListConfigurationXStore,
  setConfigurationXStoreToEdit,
  updateConfigurationXStore,
} = paymentMethodXStoreSlice.actions;

export default paymentMethodXStoreSlice.reducer;
